import { EventTypeId } from '../types/eventType';

const doubleDigitEventTypeIds = [
  EventTypeId.AMERICAN_FOOTBALL,
  EventTypeId.BASKETBALL,
  EventTypeId.TENNIS,
  EventTypeId.VOLLEYBALL
];

export const getScoreCharacterLength = (eventTypeId: EventTypeId, scores: (number | string)[]) => {
  const minCharacterLength = doubleDigitEventTypeIds.includes(eventTypeId) ? 2 : 1;
  return Math.max(minCharacterLength, ...scores.map((score) => score.toString().length));
};
